import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import { Page, Header, Alert } from 'components';

import { KPIsOverviewForm, KPIsOverviewCharts } from './components';
import { GetMetadata, SetFormState } from '../actions/KPIsOverviewActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3)
	},
	alert: {
		marginTop: theme.spacing(3)
	}
}));

const KPIsOverview = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const formState = useSelector(state => state.kpisOverviewReducer.formState);
	const metadataLoaded = useSelector(state => state.kpisOverviewReducer.metadataLoaded);

	useEffect(() => {
		// so pede o catalogo se ainda nao tiver sido carregado
		if (!metadataLoaded) {
			dispatch(GetMetadata());
		}

		/*
		 * Intervalo por omissao: os ultimos 7 dias, a acabar ontem.
		 *
		 * IDEMPOTENTE DE PROPOSITO: so preenche as datas se ainda nao houver
		 * nenhuma. Antes este efeito limpava sempre os filtros e os resultados,
		 * o que significava que qualquer remontagem do componente apagava o
		 * trabalho do utilizador -- os graficos apareciam e logo a seguir tudo
		 * voltava ao estado inicial. Nao voltar a por aqui um reset cego.
		 *
		 * ATENCAO: as datas tem de ser objectos moment, NAO Date. O componente
		 * components/DatePicker usa o AdapterMoment do @mui/x-date-pickers, que
		 * chama value.isValid() -- metodo que existe no moment mas nao no Date.
		 */
		if (!formState.values.startDate || !formState.values.endDate) {
			dispatch(SetFormState({
				...formState,
				values: {
					...formState.values,
					startDate: moment().subtract(8, 'days').startOf('day'),
					endDate: moment().subtract(1, 'days').startOf('day')
				}
			}));
		}
	}, []);

	return (
		<Page className={classes.root} title="KPIs Overview">
			<Header module="Kpis" view="KPIs Overview" />
			<KPIsOverviewForm />
			<KPIsOverviewCharts />
		</Page>
	);
};

export default KPIsOverview;
